import { render } from "./WalletDrawer.vue?vue&type=template&id=3faae418&scoped=true&ts=true"
import script from "./WalletDrawer.vue?vue&type=script&lang=ts"
export * from "./WalletDrawer.vue?vue&type=script&lang=ts"

import "./WalletDrawer.vue?vue&type=style&index=0&id=3faae418&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faae418"]])

export default __exports__